/** Keep deep links through authentication without accepting external redirects. */
export function safeAuthNext(value: string | null | undefined, locale = "ru"): string {
  const fallback = `/${locale === "en" ? "en" : "ru"}/new`;
  if (!value || value.length > 2048 || !value.startsWith("/") || value.startsWith("//") ||
      /[\\\u0000-\u0020\u007f]/.test(value) || /%(?:2f|5c|0[0-9a-f]|1[0-9a-f]|7f)/i.test(value)) return fallback;
  try {
    const parsed = new URL(value, "https://mint24.app");
    if (parsed.origin !== "https://mint24.app") return fallback;
    // Do not send users into auth callbacks, signout or a sign-in loop.
    if (/^\/(?:api(?:\/|$)|(?:(?:ru|en)\/)?(?:sign-in|sign-up|forgot-password|reset-password|verify-otp)(?:\/|$))/i.test(decodeURIComponent(parsed.pathname))) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch { return fallback; }
}
